<mat-dialog-content>
  <p>
    There were problems saving newest changes. Items will be saved once we can
    connect to the server.
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button cdkFocusInitial (click)="onClose()">Close</button>
</mat-dialog-actions>